module.exports = __webpack_public_path__ + "static/media/booking.0c85246b.svg";